<template>
  <div class="modal" v-if="visible">
	<div class="usermodal">
    <div class="header">
      <span class="title">Geregistreerd</span>
      <div class="actions">
      <button type="button" class="btn-close" @click="close">X</button>
      </div>
    </div>
    <div class="content">
    <div v-if="value && value.error">
      <strong>{{ value.name }}</strong>: {{ value.error }}
    </div>
    <div v-else-if="value && value.type === 'in'">
      Welkom <strong>{{ value.name }}</strong>, ingecheckt om {{ formatTime(value.time) }}.
    </div>
    <div v-else-if="value && value.type === 'out'">
      Tot ziens <strong>{{ value.name }}</strong>, uitgecheckt om {{ formatTime(value.time) }}.
    </div>
    <div v-else-if="value">
      Nieuwe registratie voor <strong>{{value.name}}</strong>!
    </div>
    </div>
    <loader-bar @ended="loader_end" ref="userloader" :timeout="timeout"></loader-bar>
  </div>
  </div>
</template>
<style lang="scss" scoped>
  .modal{
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    z-index: 5;
  }
  .usermodal{
    position: fixed;
    top: 50%;
    left: 50%;
    transform:translate(-50%, -50%);
    width: 80%;
    max-width: 400px;
    background:#ffffff;
    border: 1px solid #dddddd;
    z-index: 10;

    -webkit-box-shadow: 0px 0px 17px -6px rgba(0,0,0,0.46);
    -moz-box-shadow: 0px 0px 17px -6px rgba(0,0,0,0.46);
    box-shadow: 0px 0px 17px -6px rgba(0,0,0,0.46);

    .header{
      padding: 20px 40px;
      display:flex;
      justify-content:space-between;
      align-items:center;
      border-bottom: 1px solid #6e7c7c;
      .title{
        font-weight: bold;
        font-size: 2rem;
      }
      .btn-close{
        border: none;
        font-size: 2rem;
        font-weight:bold;
      }
    }

    .content{
      padding: 40px;
    }
  }
</style>
<script>
import LoaderBar from './../components/LoaderBar.vue'
export default {
  name: 'usermodal',
  components: {
      LoaderBar,
  },
  props: {
    value: Object,
    timeout: Number
  },
  data: function(){
    return {
      visible: false,
    }
  },
  updated: function(){
    if (this.visible) {
      this.$refs.userloader.start();
    }
  },
  methods: {
    formatTime: function (iso) {
      if (!iso) { return ''; }
      var d = new Date(iso);
      return ('0' + d.getHours()).slice(-2) + ':' + ('0' + d.getMinutes()).slice(-2);
    },
    loader_end: function(){
      this.close();
    },
    close: function (e) {
      if (this.$refs.userloader) {
        this.$refs.userloader.stop();
      }
      this.visible = false;
      this.$emit("close");
    },
    show: function(){
      this.visible = true;
    }
  }
};
</script>